import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { LOGO_URL } from "@/data/servers";

export default function StaffLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/staff" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dz-root min-h-screen flex items-center justify-center px-5" data-testid="staff-login-page">
      <div className="dz-grain" aria-hidden="true" />
      <form onSubmit={submit} className="relative z-10 w-full max-w-sm border border-white/10 bg-[#121314] p-8 dz-fade" data-testid="staff-login-form">
        <img src={LOGO_URL} alt="BRASIL+" className="w-16 h-16 mb-5" />
        <p className="dz-mono text-xs uppercase tracking-[0.3em] text-[#f87171] flex items-center gap-2 mb-2">
          <Lock size={12} /> Acesso restrito
        </p>
        <h1 className="dz-heading text-3xl font-black uppercase text-white mb-6">Área da staff</h1>
        <label className="dz-mono text-xs uppercase tracking-widest text-zinc-400">E-mail</label>
        <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input"
          className="mt-2 mb-4 bg-black/40 border-white/15 text-white rounded-none" />
        <label className="dz-mono text-xs uppercase tracking-widest text-zinc-400">Senha</label>
        <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input"
          className="mt-2 mb-5 bg-black/40 border-white/15 text-white rounded-none" />
        {error && <p className="text-sm text-[#f87171] mb-4" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="login-submit-button"
          className="dz-play w-full flex items-center justify-center gap-2 py-3 bg-[#c81e1e] text-white dz-heading text-lg font-extrabold uppercase tracking-wider disabled:opacity-60">
          {busy && <Loader2 size={18} className="animate-spin" />} Entrar
        </button>
      </form>
    </div>
  );
}
